"use strict";

(function ($) {
    $(document).ready(function () {
        $('.cs-why-wait').on('dragged.owl.carousel click.owl.carousel', function (e) {
            change_content('.cs-why-wait');
        });
        change_content('.cs-why-wait');
    });

    function change_content(target)
    {
        var content_id = $(target).find('.owl-carousel .owl-item.active .bg_img').attr('data-content');
        $(target + ' .bright .content').each(function () {
            if ($(this).attr('data-content') == content_id) {
                $(this).parents('.scrollbar-info').fadeIn();
            } else {
                $(this).parents('.scrollbar-info').css({'display': 'none'});
            }
        });
        $(target + ' .ltop .h_content').each(function () {
            if ($(this).attr('data-content') == content_id) {
                $(this).parents('.scrollbar-info').fadeIn();
            } else {
                $(this).parents('.scrollbar-info').css({'display': 'none'});
            }
        });
    }
})(jQuery);
